module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b2b', {
    attrs: {
      "type": "adhesion"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Serviços para Empresas")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Planos")]), _vm._v(" "), _c('p', [_vm._v("Conheça as vantagens que cada plano possui e escolha o que melhor se encaixa na necessidade do seu negócio:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-2796da64!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/services-b2b.vue
// module id = 2075
// module chunks = 1